module.exports = __webpack_public_path__ + "img/twitch.e5a0ed1a.svg";